import React from 'react';

const ContactInfo = ({ phone, location }) => {
  const handlePhoneClick = () => {
    if (phone) {
      window.open(`tel:${phone}`, '_self');
    }
  };

  const handleLocationClick = () => {
    if (location) {
      window.open(location, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg p-6">
      <h3 className="text-xl font-semibold mb-4 text-center">Contact & Location</h3>
      <div className="space-y-4">
        {phone && (
          <div className="text-center">
            <button
              onClick={handlePhoneClick}
              className="inline-flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors"
            >
              <span className="text-xl">📞</span>
              <span className="text-lg">{phone}</span>
            </button>
          </div>
        )}
        
        {location && (
          <div className="text-center">
            <button
              onClick={handleLocationClick}
              className="inline-flex items-center space-x-2 text-green-400 hover:text-green-300 transition-colors"
            >
              <span className="text-xl">📍</span>
              <span className="text-lg">View on Google Maps</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactInfo;